import { StateCreator } from 'zustand';
import { lens } from '@dhmk/zustand-lens';
import LanguageApi from '@api/LanguageApi';
import { MergedInterfaces } from '../models';
import { LanguageSlice } from '../models/LanguageSlice';

const createLanguageSlice: StateCreator<
  MergedInterfaces,
  [['zustand/persist', unknown]],
  [],
  LanguageSlice
> = (set, get) => {
  return {
    languageStore: lens((subSet, subGet, api) => ({
      languages: [],
      error: null,
      loadingLanguages: false,
      getLanguageByID: id => {
        const { languages } = subGet();
        return languages.filter(item => item.id === id)[0];
      },
      loadLanguages: async (force = false) => {
        if (!force && subGet().languages.length) {
          return;
        }

        subSet({ loadingLanguages: true, error: null });

        try {
          const languages = await LanguageApi.getLanguages();
          subSet({ languages });
        } catch (response: any) {
          subSet({ error: response?.status || 500 });
        }

        subSet({ loadingLanguages: false });
      },
      reset: () => {
        subSet({
          languages: [],
          error: null,
          loadingLanguages: false,
        });
      },
    })),
  };
};
export default createLanguageSlice;
